import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@material-ui/core/Tooltip';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  hide: {
    '& .MuiInputBase-input': {
      '-webkit-text-security': 'disc',
    },
  },
  icon: {
    width: '40px',
    height: '40px',
    '&:hover': {
      backgroundColor: theme.palette.common.pale,
    },
    '& .svg-inline--fa.fa-w-20': {
      width: '20px',
    },
    '& .svg-inline--fa.fa-w-18': {
      width: '18px',
    },
  },
  arrow: {
    left: '10px !important',
  },
  tooltip: {
    fontSize: '14px',
    margin: '16px 0',
    '@media(max-width:420px)': {
      maxWidth: '200px',
    },
  },
}));

const RenderTextField = ({
  meta: { touched, error },
  input,
  autocomplete,
  label,
  ...props
}) => {
  const classes = useStyles();
  const [showPassword, setShowPassport] = useState(false);
  const [helperText, setHelperText] = useState('');

  useEffect(() => {
    if (error && touched) setHelperText(error);
  }, [touched, error]);

  const inputProps =
    props.type === 'password'
      ? {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                className={classes.icon}
                onClick={() => setShowPassport(!showPassword)}
              >
                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
              </IconButton>
            </InputAdornment>
          ),
          classes: { root: !showPassword && classes.hide },
        }
      : {};
  return (
    <Tooltip
      open={!!(error && touched)}
      title={<FormattedMessage id={helperText} />}
      placement="bottom-start"
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      arrow
    >
      <TextField
        error={touched && error}
        autoComplete={autocomplete}
        {...input}
        {...props}
        label={label}
        type="text"
        InputProps={{
          ...inputProps,
        }}
      />
    </Tooltip>
  );
};

RenderTextField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  props: PropTypes.object,
};

RenderTextField.defaultProps = {
  disabled: false,
  placeholder: '',
  label: '',
  type: 'text',
  autocomplete: null,
  meta: {},
  props: {},
};

export default RenderTextField;
